import setupAPI from "restApi/setupApi";

// Reports a getting-started milestone to the server once per page load. The
// server ignores repeats too, so this is only to avoid pointless requests; a
// failure is silent - nothing about using the app depends on it.
const reported = new Set();

export const reportMilestone = (key) => {
  if (reported.has(key)) return;
  reported.add(key);
  setupAPI.milestone(key).catch(() => reported.delete(key));
};
